function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27,23.35c-.09.08-1.76,1.54-6.61,2.14a4.52,4.52,0,0,1-9,0c-4.69-.62-6.32-2-6.41-2.12a.74.74,0,0,1-.1-1l1.9-2.7a8.88,8.88,0,0,0,1.66-5.26V13a7.56,7.56,0,0,1,4.6-6.95V5.4A3,3,0,0,1,16,2.45h0A3,3,0,0,1,19,5.4v.65a7.56,7.56,0,0,1,4.6,7v1.4a9.13,9.13,0,0,0,1.66,5.27l1.9,2.7A.74.74,0,0,1,27,23.35ZM14.55,5.59a7.58,7.58,0,0,1,2.9,0V5.4A1.45,1.45,0,0,0,16,4h0A1.45,1.45,0,0,0,14.55,5.4Zm4.33,20.06c-.88.06-1.83.1-2.88.1s-2.15-.05-3.08-.12a3,3,0,0,0,6,0Zm6.56-3.06L24,20.53a10.62,10.62,0,0,1-1.94-6.13V13A6.05,6.05,0,1,0,10,13v1.4A10.3,10.3,0,0,1,8,20.53L6.56,22.59c1.07.58,3.84,1.66,9.44,1.66S24.36,23.17,25.44,22.59Z",
  fill: "#33ba69"
});

var SvgBorderValueIcon = function SvgBorderValueIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBorderValueIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/border_value_icon.a9dd04fa.svg";
export { ForwardRef as ReactComponent };